import { render, staticRenderFns } from "./PropertyChooseTransformsByComponentType.vue?vue&type=template&id=b0e8a170&scoped=true&"
import script from "./PropertyChooseTransformsByComponentType.vue?vue&type=script&lang=js&"
export * from "./PropertyChooseTransformsByComponentType.vue?vue&type=script&lang=js&"
import style0 from "./PropertyChooseTransformsByComponentType.vue?vue&type=style&index=0&id=b0e8a170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e8a170",
  null
  
)

export default component.exports